import { BimContractStatusEnum } from 'gql/graphql';

interface IUseStatusChangeConfirmationText {
    status?: BimContractStatusEnum;
    hasWorkOrders: boolean;
    isFrameContract: boolean;
    hasIncompleteWorkOrders: boolean;
    hasWorkOrderChangeRequired: boolean;
}

const confirmButtonText = 'Изменить';
const cancelButtonText = 'Не изменять';

export const useStatusChangeConfirmationText = (props: IUseStatusChangeConfirmationText) => {
    const { status, isFrameContract } = props;

    if (status === BimContractStatusEnum.InImplementation) {
        return {
            textConfirmation: 'Вы уверены, что хотите изменить статус на «На реализации»?',
            confirmButtonText,
            cancelButtonText,
            confirmationOnly: false,
        };
    }

    if (status === BimContractStatusEnum.Delayed) {
        const confirmationText = (
            <div style={{ display: 'flex', flexDirection: 'column', padding: '0 24px' }}>
                <div style={{ marginBottom: '16px' }}>
                    {isFrameContract
                        ? 'Дальнейшая работа по Договору, в части создания Наряд-заказов и приемки выполненных объемов, будет недоступна.'
                        : 'Дальнейшая работа по Договору, в части работы с Расчетом и приемки выполненных объемов, будет недоступна.'}
                </div>
                <div>Вы уверены, что хотите изменить статус на «Отложен»?</div>
            </div>
        );

        return {
            textConfirmation: confirmationText,
            confirmButtonText,
            cancelButtonText,
            confirmationOnly: false,
        };
    }

    if (status === BimContractStatusEnum.Completed) {
        const confirmationText = (
            <div style={{ display: 'flex', flexDirection: 'column', padding: '0 24px' }}>
                <div style={{ marginBottom: '16px' }}>
                    После перевода в статус «Завершен» дальнейшая работа по договору будет недоступна.
                </div>
                <div>Вы уверены, что хотите изменить статус на «Завершен»?</div>
            </div>
        );

        return {
            textConfirmation: confirmationText,
            confirmButtonText,
            cancelButtonText,
            confirmationOnly: false,
        };
    }

    return {
        textConfirmation: '',
        confirmButtonText: '',
        cancelButtonText: '',
        confirmationOnly: false,
    };
};
